import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { URL_PARAM_CURRENCY_PATH } from '@app/unauthenticated/currency-detail/ui/currency-detail.const';
import { CURRENCY_DETAIL_URL } from '@app/shared/const/currencies';

@Injectable({ providedIn: 'root' })
export class CurrencyDetailGuard implements CanActivate {
  constructor(private router: Router) {}

  private allowedCurrencies = Object.values(CURRENCY_DETAIL_URL);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const slug = route.paramMap.get(URL_PARAM_CURRENCY_PATH);

    if (slug && this.allowedCurrencies.includes(slug)) {
      return of(true);
    }

    this.router.navigate(['/404']);
    return of(false);
  }
}
